module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/316.eb0cc82f.png";